import { render, staticRenderFns } from "./AgendaHeader.vue?vue&type=template&id=0d4bb758&scoped=true&"
import script from "./AgendaHeader.vue?vue&type=script&lang=js&"
export * from "./AgendaHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4bb758",
  null
  
)

export default component.exports